// MultiSelectDropdown.jsx
import React, { useState, useEffect, useRef } from "react";
import "./MultiSelectDropdown.css";

export function MultiSelectDropdown({
  options = [],
  selected = [],
  onChange = () => {},
  placeholder = "Select options...",
  label,
  initialOpen = false,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (initialOpen === true) setIsOpen(true);
  }, [initialOpen]);

  const handleSelect = (value) => {
    let newSelected;
    if (selected.includes(value)) {
      newSelected = selected.filter((v) => v !== value);
    } else {
      newSelected = [...selected, value];
    }
    onChange(newSelected);
  };

  const toggleOpen = () => setIsOpen((prev) => !prev);

  return (
    <div className="multi-select" ref={dropdownRef}>
      {label && <label className="multi-select-label">{label}</label>}

      {/* Clicking the main input toggles dropdown */}
      <div className="multi-select-input" onClick={toggleOpen}>
        {selected.length === 0 ? (
          <span className="multi-select-placeholder">{placeholder}</span>
        ) : (
          <div className="multi-select-tags">
            {selected.map((value) => {
              const item = options.find((o) => o.value === value);
              return (
                <div key={value} className="multi-select-tag">
                  {item?.label || value}
                  <button
                    type="button"
                    className="multi-select-remove"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelect(value);
                    }}
                  >
                    ×
                  </button>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {isOpen && (
        <div className="multi-select-dropdown">
          {options.map((opt) => {
            const isChecked = selected.includes(opt.value);
            return (
              <div
                key={opt.value}
                // Clicking the option (not the checkbox) toggles selection
                onClick={() => handleSelect(opt.value)}
                className={`multi-select-option ${isChecked ? "selected" : ""}`}
              >
                {/* Prevent checkbox click from bubbling to the parent div */}
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => {
                    e.stopPropagation(); // Prevent parent div click
                    handleSelect(opt.value);
                  }}
                  className="multi-select-checkbox"
                />
                <span>{opt.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
